import React, { FC, useEffect } from "react";
import { Box } from "@mui/material";
import { useStoreDispatch, useStoreSelector } from "../../../hooks/StoreHooks";
import { useNavigate } from "react-router-dom";
import { Events, useEventBroadcast } from "../../../core/EventBroadcast";
import { StepSlugsEnum } from "../../core/common_types";
import { usePergolaConfigurationBuilderActions } from "../../../store/reducers/pergola_configuration_builder";
export type Steps = { slug: StepSlugsEnum, title: string, image: string | null, isComplete: boolean, isActive: boolean, isVisible: boolean, callback?: boolean, }
export const ConfigurationStepperPergola: FC<{area: string, steps: Steps[]}> = ({area, steps}) => {
    const { pergolaConfigurationBuilder } = useStoreSelector(store => store);
    const { setStepActive, setStepComplete } = usePergolaConfigurationBuilderActions();
    const { setSteps } = usePergolaConfigurationBuilderActions();
    const dispatcher = useStoreDispatch();
    const navigate = useNavigate();
    const { dispatch: broadcast } = useEventBroadcast();

    useEffect(() => {
        dispatcher(setSteps(steps));
    }, []);

    const getAdditionalClassNames = (step: Steps): string => {
        let classes: string[] = [];
        if (step.isActive) classes.push("active");
        else if (step.isComplete) classes.push("completed");
        return classes.join(" ");
    }

    const changeStep = (step: Steps) => {
        if (!step.isComplete) return null;
        if(step.callback){
            broadcast(Events.stepChange, { stepSlug: step.slug });
            dispatcher(setStepActive({ stepSlug: step.slug, isActive: true }));
        }
        let url = `/${area}/${pergolaConfigurationBuilder.configuration?.configurationId}/${step.slug}`;
        navigate(url);
    }

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"start"} sx={{backgroundColor: "#f1f1f1", overflow: "auto"}} component="div">
            {!pergolaConfigurationBuilder.steps && <h6>Attendere...</h6>}
            {pergolaConfigurationBuilder.steps && pergolaConfigurationBuilder.steps.filter(s => s.isVisible).map((s, idx) => (
                <div key={"step_"+(idx+1)} className={"configuration-stepper m-3 d-flex flex-column justify-content-center align-items-center " + getAdditionalClassNames(s)} onClick={() => changeStep(s)}>
                    <div className="configuration-stepper-icon">{s.image && <img src={s.image} />}</div>
                    <div className="configuration-stepper-title-container">
                        <span className="configuration-stepper-title">{s.title}</span>
                    </div>
                </div>
            ))}
        </Box>
    );
}
